(function ($) {

    if ($('.template-search').length) {

        var searchBar = $('.search-bar');
        var searchInput = searchBar.find('.search-input');
        var inputValue = searchInput[0].value;
        var searchTrigger = searchBar.find('.search-trigger');
        var results = $('.search-results');
        var searchQuery = $('.search-query');
        var noResultsQuery = $('.no-results-query');
        var filterContainer = results.find('.filters');
        var searchLoader = results.find('.loader');
        var resultsList = results.find('.results-list');
        var noResultsNotice = results.find('.no-results-notice');
        var suggestedLinks = $('.suggested-links-list');

        var showFilterBtn = $('.search-filter-trigger.mobile')

        searchInput.on('change, keyup', function (e) {   // Search on Enter
            if (e.keyCode === 13) {
                searchTrigger.click();
            }
            inputValue = searchInput[0].value;
        });

        searchTrigger.on('click', function () {
            if (inputValue) {
                searchLoader.addClass('active');
                noResultsNotice.removeClass('active');
                filterContainer.addClass('hide');
                showFilterBtn.addClass('hide');
                suggestedLinks.addClass('hide');
                resultsList.empty();

                $.ajax({
                    url: postmpwp.home_url + "?s=" + inputValue,
                    type: "GET",
                    dataType: "json",
                    success: function (response) {
                        searchLoader.removeClass('active');
                        searchQuery.text(inputValue);
                        $('.with-query-string').removeClass('hide');
                        $('.without-query-string').addClass('hide');
                        searchInput[0].value = "";

                        if (response.items.length) {
                            filterContainer.removeClass('hide');
                            showFilterBtn.removeClass('hide');
                            suggestedLinks.addClass('hide');
                            response.items.forEach(function (item) {
                                resultsList.append(JSON.parse(item));
                            });
                        } else {
                            noResultsQuery.text(inputValue);
                            noResultsNotice.addClass('active');
                            filterContainer.addClass('hide');
                            showFilterBtn.addClass('hide');
                            suggestedLinks.removeClass('hide');
                        }
                    }
                });
            }
        });

        $(window).on('load', function () {
            if (inputValue.length > 0) {
                searchTrigger.click();
            }
        })

        // SEARCH FILTER

        var filterItems = document.querySelectorAll('.filter-item');
        var filters = [];

        filterItems.forEach(function (filter, idx) {
            filter.addEventListener('click', function () {
                this.classList.toggle('active');
                var selectedFilterID = this.getAttribute('data-filter-id')
                if (filters.includes(selectedFilterID)) {
                    filters = filters.filter(function (item) {
                        return item !== selectedFilterID
                    })
                } else {
                    filters.push(selectedFilterID);
                }

                if(filters.length === 0){
                    $('.results-list-item').removeClass('hide');
                }else{

                    $('.results-list-item').addClass('hide');
                    filters.forEach(function (filter) {
                        $('.results-list-item[data-category="'+filter+'"]').removeClass('hide');
                        $('.results-list-item[data-topics*="'+filter+'"]').removeClass('hide');
                    });
                }
            })
        })

        // SEARCH FILTER - MOBILE

        var hideFilterBtn = $('.hide-filter-trigger.mobile');

        showFilterBtn.on('click', function(){
            filterContainer.addClass('active');
        })
        hideFilterBtn.on('click', function(){
            filterContainer.removeClass('active');
        })
    }

})(jQuery);